export const SHOW_VIEW_PAGE = "SHOW_VIEW_PAGE";
export const HIDE_VIEW_PAGE = "HIDE_VIEW_PAGE";
export const SET_KEY_NAME = "SET_KEY_NAME";
